import useResponsiveDesign from './useResponsiveDesign'

interface Props {
  mobileFunction?: () => void
  defaultFunction?: () => void
}

const useResponsiveFunction = ({ mobileFunction, defaultFunction }: Props) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? mobileFunction : defaultFunction
}

export default useResponsiveFunction
